export default __webpack_public_path__ + "c760e90e33c69a4ba0949d2773b047ab.svg";